<ng-container *ngIf="store.state$ | async as userProfile">
  <app-personal-details
    (submitUserProfile)="submitUserProfile($event)"
    [userProfile]="userProfile"
    [buttonText]="'Global.Continue' | translate"
    #personalDetails
  ></app-personal-details>
</ng-container>
<app-auth-card-footer class="w-100 d-block">
  <a (click)="logout()" translate="Register.LogoutText"></a>
</app-auth-card-footer>
